import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function ProductFilters({
  category,
  onCategoryChange,
  categories,
  loading,
  disabled,
}) {
  return (
    <FormControl
      size="small"
      sx={{ minWidth: 200, flex: "0 1 220px" }}
      disabled={disabled}
    >
      <InputLabel>Category</InputLabel>
      <Select
        value={category}
        label="Category"
        onChange={(e) => onCategoryChange(e.target.value)}
        disabled={loading || disabled}
      >
        <MenuItem value="">All categories</MenuItem>
        {categories.map((cat) => (
          <MenuItem key={cat.id ?? cat.slug ?? cat.name} value={cat.name}>
            {cat.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
